import React, { useEffect, useRef, useState } from "react";
import DocumentsTable from "./tables/DocumentsTable";
import { useMediaQuery } from "react-responsive";
import { notifyError } from "../../../helpers/helpers";
import { useDispatch, useSelector } from "react-redux";
import imageCompression from 'browser-image-compression';
import documentList from "../../../jsonData/Documents.json";
import {
  getAllDocumentsData,
  uploadDocumentsData,
} from "../../../redux/action/document";
import { ClipLoader } from "react-spinners";

const DocumnentsCollection = () => {
  const isTablet = useMediaQuery({ query: "(max-width: 990px)" });
  const isTabletSmall = useMediaQuery({ query: "(max-width: 550px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 440px)" });
  const [uploadValue, setUploadValue] = useState({
    file: null,
    fileType: "",
  });
  const [toggleDocuments, setToggleDocuments] = useState(false);
  const fileInputRef = useRef(null);
  const dispatch = useDispatch();
  const { documentData, loadings, uploadLoading } = useSelector((pre) => pre.allDocuments);

  const handleSelect = (e) => {
    setUploadValue({ ...uploadValue, fileType: e.target.value });
  };

  const handleAddFile = () => {
    dispatch(uploadDocumentsData(uploadValue, setUploadValue));
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (
      file &&
      ["application/pdf", "image/png", "image/jpeg", "image/jpg"].includes(
        file.type
      )
    ) {

      try {
        let compressedFile = file;
        if (file.type !== "application/pdf") {
          // Compress image
          const options = {
            maxSizeMB: 0.1,
            maxWidthOrHeight: 1080,
            useWebWorker: true,
          };
          const compressedBlob = await imageCompression(file, options);
          compressedFile = new File(
            [compressedBlob],
            file.name,
            { type: file.type }
          );
        }
        setUploadValue({ ...uploadValue, file: compressedFile });
      } catch (error) {
        console.error("Compression error:", error);
        notifyError("Failed to compress file.");
      }

    } else {
      setUploadValue({ ...uploadValue, file: null });
      notifyError(
        "Unsupported Format. Only JPG, JPEG,PNG, and PDF files are allowed."
      );
    }
  };

  const handleSpanClick = () => {
    fileInputRef.current.click();
  };

  useEffect(() => {
    dispatch(getAllDocumentsData());
  }, [dispatch]);

  return (
    <div className="mt-1 pin-top">
      <div
        className={`${!isMobile && "valign-wrapper space-between"}`}
        style={{ marginBottom: "7px" }}
      >
        <h4>Document</h4>
        <span
          className={`white valign-wrapper gap-1 pointer bold font-18px justify-center ${isMobile && "mt-1"
            }`}
          style={{
            padding: "0.5rem 1rem",
            borderRadius: "7px",
            border: "2px solid rgba(0, 0, 0, 0.1)",
          }}
          onClick={() => setToggleDocuments((prev) => !prev)}
        >
          <span className="material-symbols-outlined">add</span>
          <h6 className="margin-0px">Add Document</h6>
        </span>
      </div>
      <div
        className="cover white"
        style={{ padding: isTablet ? "2rem" : "10px 50px" }}
      >
        {toggleDocuments && (
          <div
            className={`flex ${isTablet ? "justify-center full-width column" : ""
              } gap-3`}
          >
            <span style={{ width: !isTablet && "35%" }}>
              <span className="black-text font-18px bold">
                Add Documents
              </span>
              <select
                className="browser-default"
                style={{ padding: "12px 10px" }}
                onChange={handleSelect}
              >
                <option value="">Select and add more documents</option>
                {documentList.map((item) => (
                  <option key={item.label} value={item.label}>
                    {item.name}
                  </option>
                ))}
              </select>
            </span>
            {uploadValue.fileType && (
              <div
                className={`flex gap-2 ${isTabletSmall && "column justify-center"
                  }`}
                style={{ width: isTablet ? "100%" : "48%" }}
              >
                <div style={{ minWidth: isTablet ? "60%" : "80%" }}>
                  <label
                    className="black-text font-16px"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    {uploadValue.fileType}
                  </label>
                  <span
                    className="valign-wrapper mr-1 pointer border-1px"
                    style={{
                      padding: "11px",
                      width: "100%",
                      borderRadius: "7px",
                      position: "relative",
                    }}
                    onClick={handleSpanClick}
                  >
                    <p>
                      {uploadValue.file?.name || (
                        <span className="grey-text">
                          Accepted file formats: .jpeg, .jpg, .pdf only.
                        </span>
                      )}
                    </p>
                    <span
                      className="material-icons-outlined cercle-purple-text"
                      style={{
                        position: "absolute",
                        top: "23%",
                        right: "3%",
                        fontSize: "25px",
                      }}
                    >
                      cloud_upload
                    </span>
                    <input
                      type="file"
                      id="file-input"
                      accept=".jpg, .jpeg, .pdf, .png"
                      onChange={handleFileChange}
                      style={{ display: "none" }} // Hide the default file input
                      ref={fileInputRef} // Reference to the input element
                    />
                  </span>
                </div>
                <button
                  className={`button-style pointer font-16px ${uploadValue.file ? "cercle-purple white-text" : ""
                    }`}
                  style={{
                    border: !uploadValue.file && " 1px solid black",
                    padding: "3px 50px",
                    height: "45px",
                    marginTop: !isTabletSmall && "25px",
                  }}
                  disabled={!uploadValue.file?.name || uploadLoading}
                  onClick={handleAddFile}
                >
                  {uploadLoading ? <ClipLoader color="red" size={20} /> : "Upload"}
                </button>
              </div>
            )}
          </div>
        )}
        <DocumentsTable documentValue={documentData} loadings={loadings} />
        {/* <DetailsLinks />
        <div className="flex justify-center mt-1">
          {toggleDocuments && (
            <Link to="/">
              <button
                className="button-style white-text cercle-purple pointer"
                style={{ padding: "12px 45px" }}
              >
                Done
              </button>
            </Link>
          )}
        </div> */}
      </div>
    </div>
  );
};

export default DocumnentsCollection;
